import React, { useEffect, useState } from 'react'
import Report from '@containers/Report'
import './index.css'

import { SimpleCard } from '@components/AdminCard'
import InlineLoader from '@components/InlineLoader'
import { getSapDashboard } from '@services/sm-api'

const CARDS = [
  {
    key: 'enqueued_orders',
    title: 'Pedidos enfileirados',
    description: 'Subpedidos atualmente na fila SAP_ORDER aguardando envio ao SAP.',
    color: '#6AABD6',
  },
  {
    key: 'failed_orders',
    title: 'Pedidos com falhas',
    description: 'Subpedidos que com falha no envio ao SAP.',
    color: '#F5A8A8',
  },
  {
    key: 'processed_orders',
    title: 'Pedidos processados com sucesso',
    description: 'Subpedidos enviados ao SAP com sucesso.',
    color: '#8DC496',
  },
]

const SAP = () => {
  const [counters, setCounters] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let mounted = true

    getSapDashboard()
      .then(data => {
        if (mounted) {
          setCounters(data)
          setLoading(false)
        }
      })
      .catch(() => {
        if (mounted) {
          setError(true)
          setLoading(false)
        }
      })

    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className="sap">
      <div className="sap__header">
        <h3 className="sap__title">Integração SAP</h3>
        <h2 className="sap__subtitle">Campanha {counters && counters.current_campaign ? counters.current_campaign : ''}</h2>
      </div>

      {loading && <InlineLoader show />}

      {!loading && error && (
        <p className="sap__error">Não foi possível carregar os indicadores do SAP. Tente novamente mais tarde.</p>
      )}

      {!loading && !error && (
        <div className="sap__cards">
          {CARDS.map(card => (
            <SimpleCard
              key={card.key}
              className="sap__card"
              title={card.title}
              value={counters && counters[card.key] != null ? counters[card.key] : 0}
              color={card.color}
              position="bottom"
            >
              <span className="sap__card-description">{card.description}</span>
            </SimpleCard>
          ))}
        </div>
      )}

      <div className="sap__report">
        <Report
          title=""
          subTitle="Falhas de integração"
          type="sap_order_log"
          url="orders/sap/report/list"
        />
      </div>
    </div>
  )
}

export default SAP
